import styled from "styled-components";
import theme from "~/styles/theme";

export const PageHolder = styled.div`
  padding: 0 16px;
  width: 100%;
  text-align: center;
`;

export const TitleHolder = styled.div`
  max-width: 240px;
  margin: 0 auto;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: unset;
  }
  h1 {
    font-family: ${theme.typography.secondaryFont};
  }
`;
export const TextHolder = styled.div`
  margin: 0 auto;
  p,
  span,
  strong {
    color: ${theme.palette.neutral.primary.key};
    font-family: ${theme.typography.fontFamilyRegular};
  }

  strong {
    font-family: ${theme.typography.fontFamily};
    line-height: 15px;
  }

  > div {
    position: relative;
    margin: 0 auto;
    display: block;
    span {
      color: inherit;
    }
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 839px;
  }
`;
export const EmailHolder = styled.div`
  max-width: 496px;
  padding: 28px 0;
  border-radius: 500px;
  background-color: ${theme.palette.neutral.primary.light};
  border-radius: 500px;
`;

export const ButtonHolder = styled.div`
  margin: 0 auto;
  button {
    width: 100%;
    padding: 14px 22px;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 496px;
  }
`;


export const Email = styled.div`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-radius: 1000px;
  background: var(--cores-ffffff, #FFF);
  padding: 16px 40px;
  min-width: 300px;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: inline-block;
  }
`;

export const PageContainer = styled.div`
  background-color: #F5F5F5;
`;

export const Message = styled.div`
  text-align: center;
  > div {
    justify-content: center;
  }
`;